<script setup>
import { text } from '@fortawesome/fontawesome-svg-core';

defineProps({
    clickAction: {
        type: Function,
        default: () => { },
    },
    type: {
        type: String,
        default: 'submit',
    },
    buttonText: {
        type: String,
        default: 'Submit',
    },
    icon: {
        type: String,
        default: '',
    },
    isNarrow: {
        type: Boolean,
        default: false,
    },
    saveState: {
        type: String,
        default: '',
    },
    textSize: {
        type: String,
        default: 'text-lg',
    },
});
</script>

<template>
    <button 
        :type="type" 
        :disabled="saveState === 'saving'"
        class="items-center justify-between flex gap-3 bg-(--brand-colour) text-white border border-(--brand-colour) hover:bg-white hover:text-(--brand-colour) transition-all rounded-full cursor-pointer"
        :class="{
            'py-4 px-5': buttonText !== '' && !isNarrow,
            'py-2 px-4': buttonText !== '' && isNarrow,
            'p-4': buttonText == '',
            [textSize]: true,
        }"
        @click="clickAction"
    >
        <span v-if="buttonText" v-text="buttonText" />
        <font-awesome-icon v-if="icon && saveState ===''" :icon="'fa-light fa-' + icon" size="lg" />
        <font-awesome-icon v-if="icon && saveState ==='saving'" icon="fa-light fa-spinner-scale" size="lg" spin />
        <font-awesome-icon v-if="icon && saveState ==='saved'" icon="fa-light fa-thumbs-up" size="lg" />
        <font-awesome-icon v-if="icon && saveState ==='error'" icon="fa-light fa-thumbs-down" size="lg" />
    </button>
</template>
